/* eslint-disable max-len */
type HotjarAttribute = string | number | boolean | null | undefined;
type HotjarAttributes = Record<string, HotjarAttribute>;

declare global {
  interface Window {
    hj?: (...args: unknown[]) => void;
  }
}

export const isHotjarReady = () => typeof window !== 'undefined' && typeof window.hj === 'function';

export const trackHotjarEvent = (eventName: string) => {
  if (!isHotjarReady()) return;
  window.hj?.('event', eventName);
};

export const identifyHotjarUser = (
  userId: string | null,
  attributes: HotjarAttributes = {},
) => {
  if (!isHotjarReady() || !userId) return;

  const cleanAttributes = Object.entries(attributes).reduce<HotjarAttributes>((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      acc[key] = value;
    }
    return acc;
  }, {});

  window.hj?.('identify', userId, cleanAttributes);
};

export const trackHotjarRoute = (path: string) => {
  if (!isHotjarReady()) return;
  window.hj?.('stateChange', path);
};
